import React from "react";
import "./Rewards.css";
import { LanguageDirection } from "../../utility/LanguageDirection";

const Rewards = () => {
  const direction = LanguageDirection();
  const lang = localStorage.getItem('i18nextLng') || 'en'



  return (
    <section className={`rewards ${direction === 'rtl' && ('rtl')}`}>

        <div
        style={{
          paddingRight:"8px",
          paddingLeft: direction === "rtl" ? "8px" : "0", // Adjust padding for RTL layout
        }}
        >
      </div>
      <div style={{ 
      width: '100%', 
      height: '100%', 
      overflow: 'hidden' 
    }}>
      <iframe 
      title="Merchants List"
        src={`https://programs.remmsh.com/wallet-demo/${['en', 'ar'].includes(lang) ? lang : 'en'}`}
        width="100%" 
        height="100%" 
        style={{
          border: 'none',
          minHeight: '100vh',
          scrollbarWidth: 'thin', // For Firefox
          scrollbarColor: 'black transparent', // For Firefox
          
        }}
        className="custom-scrollbar"
      />
      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 8px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: transparent;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background-color: black;
          border-radius: 4px;
        }
      `}</style>
    </div>
    </section>
  );
};

export default Rewards;
